export default __webpack_public_path__ + "static/media/a011-startup-4.ec7537a3.svg";